import React from "react";
import { RCCButton, RCCTooltip } from "react-common-components";
import { Link } from "react-router-dom";
import AppIcons from "src/components/AppIcons";
import DefaultBody from "src/components/DashboardComponents/DefaultDashboardComponents/DefaultBody";
import DefaultContainer from "src/components/DashboardComponents/DefaultDashboardComponents/DefaultContainer";
import { useTranslation } from "src/context/Translations/context";
import useEffectFetchData from "src/hooks/useEffectFetchData";
import ListOfMeetings from "src/pages/Meetings/Panel/components/listOfMeetings";
import { IMeetingListDTO } from "src/pages/Meetings/Panel/interface";
import HeaderDashboard from "../../../DefaultDashboardComponents/HeaderDashboard";
import { ICardConfigs } from "../../../interface";

const DashboardListMeetings: React.FC<ICardConfigs> = ({
	card
}) => {
	const { translate } = useTranslation();
	
	const {data , loading} = useEffectFetchData<IMeetingListDTO[]> (
		"DashboardMeetings/ListMyMeetings"
	);
	
	return (
		<DefaultContainer>
			<HeaderDashboard 
				description={card?.daa002Descricao}
				title={card && card.daa002Titulo.trim().length > 0 ? card.daa002Titulo : translate("Lista Minhas Próximas Reuniões")}
				hexColor={card?.daa002Cor !== null ? card?.daa002Cor : undefined}
				isLoading={loading}
			>
				
				<Link to="/meeting/panel">
					<RCCTooltip
						text={translate("Painel de Reuniões")}
						color="grey"
					>
						<RCCButton
							color="transparent"
						>
							<AppIcons 
								name="meeting"
								size={14}
							/>
						</RCCButton>
					</RCCTooltip>
				</Link>
			</HeaderDashboard>
			
			<DefaultBody>
				{data && (
					<ListOfMeetings 
						data={data} 
						callBackFunction={() => null} 
						options={() => <> </>}			
						layout="table"		
						origin="dashboard"
					/>
				)}
			</DefaultBody>
		</DefaultContainer>
	);
};

export default DashboardListMeetings;
